/**
 * @generated SignedSource<<4472993a287928f86c7564300966cf07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteClassExitSlipInput = {
  classExitSlipId: string;
};
export type ExitSlipDeleteClassExitSlipMutation$variables = {
  input: DeleteClassExitSlipInput;
};
export type ExitSlipDeleteClassExitSlipMutation$data = {
  readonly deleteClassExitSlip: {
    readonly classExitSlipNode: {
      readonly dueOn: any;
      readonly id: string;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null | undefined;
  };
};
export type ExitSlipDeleteClassExitSlipMutation = {
  response: ExitSlipDeleteClassExitSlipMutation$data;
  variables: ExitSlipDeleteClassExitSlipMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ClassExitSlipNode",
  "kind": "LinkedField",
  "name": "classExitSlipNode",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueOn",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "UnauthorizedAccessError",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "InvalidIdsError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExitSlipDeleteClassExitSlipMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteClassExitSlipPayload",
        "kind": "LinkedField",
        "name": "deleteClassExitSlip",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExitSlipDeleteClassExitSlipMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteClassExitSlipPayload",
        "kind": "LinkedField",
        "name": "deleteClassExitSlip",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "76382b130a093de49df540fd0e53393d",
    "id": null,
    "metadata": {},
    "name": "ExitSlipDeleteClassExitSlipMutation",
    "operationKind": "mutation",
    "text": "mutation ExitSlipDeleteClassExitSlipMutation(\n  $input: DeleteClassExitSlipInput!\n) {\n  deleteClassExitSlip(input: $input) {\n    classExitSlipNode {\n      id\n      dueOn\n    }\n    errors {\n      __typename\n      ... on UnauthorizedAccessError {\n        message\n      }\n      ... on InvalidIdsError {\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "63ebcad5e2d10ef6a750587b8b234cbd";

export default node;
